import get from 'lodash/get';
import { format } from 'date-fns';
import { Data, EventData } from 'prismic/types';
import CmsElmtWrapper from 'components/organisms/CmsElmtWrapper/CmsElmtWrapper';
import PageBackground from 'components/atoms/PageBackground/PageBackground';
import Header from 'components/organisms/Header/Header';
import { Footer } from 'components/organisms/Footer';
import { Hero } from 'components/organisms/Hero';
import { Separator } from 'components/organisms/Separator';
import { MuseumPlan } from 'components/organisms/MuseumPlan';
import ComponentsRenderer from './partials/ComponentsRenderer';
import TemplateWrapper from './partials/TemplateWrapper';
import { HeaderSpacer } from 'components/atoms/HeaderSpacer';

interface EventTemplateProps {
  data: EventData;
  header: any;
  footer: Data;
}

const EventTemplate: React.FC<EventTemplateProps> = ({ data, header, footer }) => {
  const { alternate_languages } = data;

  const termineArray = data.data.body.map(
    (item: {
      items: {
        [x: string]: string | number | Date;
        event_start: string | number | Date;
      }[];
    }) => {
      const eventStart = new Date(item.items[0].event_start);
      const nextDateEnd = new Date(item.items[0].event_end);
      return {
        nextDate: new Date(item.items[0].event_start),
        nextTimeslot: `${format(eventStart, 'kk:mm')} - ${format(nextDateEnd, 'kk:mm')}`,
      };
    }
  );

  const heroPrimary = {
    headline: data.data.title,
    image: data.data.image,
    intro_text: data.data.description,
    subheadline: '',
    show_breadcrumb: true,
    show_social_sharing: true,
    big_image: false,
    times: termineArray,
  };
  return (
    <TemplateWrapper pageId={data.id} data={data}>
      <PageBackground />
      <Header {...header} alternateLanguages={alternate_languages} />
      <HeaderSpacer />
      <CmsElmtWrapper sliceName="hero" nextSlice="default">
        <Hero primary={heroPrimary} />
      </CmsElmtWrapper>
      <ComponentsRenderer slices={get(data, 'data.body1', [])} />
      <Separator primary={{ horizontal_line: true }}></Separator>
      <MuseumPlan />
      <Footer data={get(footer, 'data.body', [])} />
    </TemplateWrapper>
  );
};

export default EventTemplate;
